<div class="container-fluid pt-3">
  <div
    class="row"
    style="
      display: flex;

      align-items: center;
    "
  >
    <ngx-spinner
      bdColor="rgba(100,112,124,0.56)"
      size="medium"
      color="#233547"
      type="ball-clip-rotate-multiple"
      [fullScreen]="true"
    >
      <p style="color: white"></p>
    </ngx-spinner>
    <div class="col-md-6 w-100 pr-0">
      <div class="d-flex justify-content-between">
        <div class="header-infos">
          <p
            class="m-0 text-uppercase"
            style="font-size: 20px; color: #262756; font-weight: bold"
          >
            Rapports
          </p>
          <small class="text-uppercase" style="font-size: 15px; color: #707070"
            >Historique</small
          >
        </div>
        <div style="width: 47%">
        </div>
      </div>
    </div>
    <div class="col-md-5 w-100">
      <div
        class="row px-3"
        style="display: flex; justify-content: flex-end"
      ></div>
    </div>
  </div>
  <div class="row pt-2">
    <div class="col-sm-12 col-xs-12 col-xl-3 col-lg-3 col-md-12 w-100 pl-0">
      <div class="mb-2">
        <div class="export-icons d-flex mb-2">
          <div placement="bottom" class="favoris">
            <a
              [routerLink]="['/user/report']"
              routerLinkActive="router-link-active"
            >
              <img
                ngbTooltip="Générer rapport"
                src="assets/icons/GenerateReport.svg"
              />
            </a>
          </div>
          <div placement="bottom" class="favoris">
            <a
              [routerLink]="['/user/reportfavorite']"
              routerLinkActive="router-link-active"
            >
              <img ngbTooltip="Favoris" src="assets/icons/favoris.svg" />
            </a>
          </div>
          <div placement="bottom" class="planification">
            <a
              [routerLink]="['/user/plannification']"
              routerLinkActive="router-link-active"
            >
              <img
                ngbTooltip="Plannifier un rapport"
                src="assets/icons/planification.svg"
              />
            </a>
          </div>
          <div placement="bottom" class="historique">
            <a
              [routerLink]="['/user/reportHistory']"
              routerLinkActive="router-link-active"
            >
              <img ngbTooltip="Historique" src="assets/icons/historique.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr style="border: 1px solid #e8e4e4; margin-top: 0%" />
  <div class="row">
    <div class="col-xl-12 col-md-12 w-100 pl-0">
      <div class="row">
        <!-- <div class="col-2 col-md-2 w-100">
          <mat-form-field appearance="fill">
            <mat-label>Choisir une page</mat-label>
            <mat-select>
              <mat-option
                *ngFor="let item of collection"
                (click)="updateManualPage(item - 1)"
                [value]="item"
              >
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
        <!-- <div class="col-5 col-md-5sdftt w-100 pl-0">
          <mat-form-field appearance="fill">
            <mat-label>Nombre d'éléments</mat-label>
            <mat-select [(ngModel)]="pageSize">
              <mat-option
                (click)="updateManualPage2(pageSize)"
                *ngFor="let pageSize of pageSizeOptions"
                [value]="pageSize"
              >
                {{ pageSize }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div> -->
        <!-- <div class="col-6 col-md-5 w-100 mb-2 d-flex">
          <mat-form-field
            appearance="fill"
            style="width: 100%; margin-bottom: 5px"
          >
            <mat-label>Chercher dans historique des rapports</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              #input
              placeholder="Chercher"
            />
            <mat-icon
              matSuffix
              placement="left"
              ngbTooltip="Chercher un ou plusieurs rapports"
              >search</mat-icon
            >
          </mat-form-field>
        </div> -->
      </div>
      <div class="example-container mat-elevation-z8">
        <table
          mat-table
          #exportDirective="matTableExporter"
          matTableExporter
          [dataSource]="dataSource"
          matSort
        >
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
              >
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
                [aria-label]="checkboxLabel(row)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Type de Rapport
            </th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="element?.type == 1">Rapport de flotte</div>
              <div *ngIf="element?.type == 2">Rapport détaillé</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="export_type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Type d'export
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              [style.color]="element?.export_type"
            >
              <div style="padding-left: 33px !important">
                <img
                  placement="right"
                  ngbTooltip="PDF"
                  src="assets/newImages/pdf-svg.svg"
                />
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Date de Création
            </th>
            <td mat-cell *matCellDef="let element">{{ element?.created_at }}</td>
          </ng-container>
          <ng-container matColumnDef="start_period">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Date de début de période
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              (contextmenu)="onContextMenu($event, element)"
              class="centrerElementTableau"
            >
              {{ element?.start_period }}
            </td>
          </ng-container>
          <ng-container matColumnDef="end_period">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Date de fin de période
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              (contextmenu)="onContextMenu($event, element)"
              class="centrerElementTableau"
            >
              {{ element?.end_period }}
            </td>
          </ng-container>
          <ng-container matColumnDef="downloads">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Nombre de Télechargement
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              (contextmenu)="onContextMenu($event, element)"
              class="centrerElementTableau"
            >
              <b class="text-uppercase"> {{ element?.downloads }}</b>
            </td>
          </ng-container>
          <ng-container matColumnDef="telechargement">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Télecharger
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              (contextmenu)="onContextMenu($event, element)"
            >
              <div style="padding-left: 30px !important">
                <img
                  placement="right"
                  ngbTooltip="Télecharger"
                  (click)="generatePfdLog(element)"
                  src="assets/icons/upload.svg"
                />
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="selection.toggle(row)"
          ></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="12">
              Aucune donnée correspondante à votre recherche
            </td>
          </tr>
        </table>
        <mat-paginator
          #paginator
          [pageSize]="15"
          [length]="dataSource?.data.length"
         [pageSizeOptions]="[15, 30, 100]"
         (page)="pageChanged($event)"
          [showFirstLastButtons]="true"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
